import { CommandGetStorePage } from "./commands/cmdGetStorePage";
import { CommandGetStoreCollection } from "./commands/cmdGetStoreCollection";


export class StoreService{
    async getStorePage(organizationId: string, name: string) {
        const cmd = new CommandGetStorePage();
        const results = await cmd.run(organizationId, name);
        return results;
    }

    async getCollection(organizationId: string, collectionId: string, name: string) {
        const cmd = new CommandGetStoreCollection();
        const results = await cmd.run(organizationId, collectionId, name);
        return results;
    }
}
